// removed by extract-text-webpack-plugin
module.exports = {"section":"billboard__section___2P6Zh","headlineWrapper":"billboard__headlineWrapper___2r7dV","billboard":"billboard__billboard___3PEVj","visual":"billboard__visual___3L5ZT","headline":"billboard__headline___YKRVB","fadein":"billboard__fadein___1779C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/billboard/billboard.scss
// module id = 387
// module chunks = 0